export const TEXT = {
  CLAIM: {id: 'raf.referrals.title'},
  EXPLANATION: {id: 'raf.referrals.body'},
} as const;
